import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 5 minutes before data is considered stale
      staleTime: 5 * 60 * 1000,
      // Cache time: 30 minutes before inactive data is garbage collected
      gcTime: 30 * 60 * 1000,
      // Retry failed queries 3 times
      retry: 3,
      // Don't retry on 4xx errors
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Refetch on window focus in production
      refetchOnWindowFocus: import.meta.env.PROD,
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
    mutations: {
      // Don't retry mutations by default
      retry: false,
    },
  },
});
